import { translate } from '../../../../../types/translation/Translator';
import React, { useContext, useState } from 'react';
import { ExportItems } from '../../../../components/ExportItems';
import { Routing } from '../../../../../util/routes.util';
import { useRequest } from '../../../../../requests/common/requestHook';
import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import { ActionModal } from '../../../../components/Modal';
import { Button, CancelButton } from '../../../../components/Button';
import moment from 'moment';
import { ExportUtil } from '../../../../../util/export.util';
import { ExportFile } from '../../../../../types/export/export';
import { ProductMasterDataExportConfigurationContext } from '../../../../../context/ProductMasterDataExportConfigurationContext';
import { ProductMasterDataExportConfigurationRequest } from '../../../../../requests/productMasterDataExportConfiguration.request';

interface ProductMasterDataExportModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function ProductMasterDataExportModal({ open, setOpen }: ProductMasterDataExportModalProps) {
  const { productMasterDataExportConfigurations, productMasterDataExportConfigurationsLoading } = useContext(
    ProductMasterDataExportConfigurationContext,
  );

  const [exportProducts, { loading }] = useRequest(ProductMasterDataExportConfigurationRequest.download);

  const [selected, setSelected] = useState<Set<string>>(
    new Set(
      [...productMasterDataExportConfigurations.values()].filter(config => config.default).map(config => config.id),
    ),
  );
  const handleClose = () => {
    setOpen(false);
  };

  const handleDownload = async () => {
    if (!selected.size) {
      const file = await exportProducts({
        timezone: moment.tz.guess(),
        locale: (window.navigator as any)['userLanguage'] || window.navigator.language,
      });
      if (!file) return;
      ExportUtil.downloadExport(file);
    } else {
      const files: ExportFile[] = [];
      for (const configId of Array.from(selected)) {
        const file = await exportProducts({
          configId,
          timezone: moment.tz.guess(),
          locale: (window.navigator as any)['userLanguage'] || window.navigator.language,
        });
        if (file) files.push(file);
      }
      if (!files.length) return;

      if (files.length === 1) {
        ExportUtil.downloadExport(files[0]);
      } else {
        ExportUtil.downloadZip(files, productMasterDataExportConfigurations);
      }
    }

    setSelected(new Set());
    handleClose();
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <CancelButton onClick={handleClose} disabled={loading} />
      <Button loading={loading} text={translate({ key: TranslationKey.export })} onClick={handleDownload} />
    </div>
  );

  return (
    <ActionModal
      footer={footer}
      title={translate({ key: TranslationKey.exportProductReferences })}
      open={open}
      setOpen={setOpen}
      className='max-w-[720px]'
    >
      <ExportItems
        items={[...productMasterDataExportConfigurations.values()]}
        selected={selected}
        setSelected={setSelected}
        createPath={Routing.stock.products.settings.report.create()}
      />
    </ActionModal>
  );
}
